import React from 'react';

import LottieView from 'lottie-react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { isNative } from 'utils/environment';

import { AnimationProps } from './types';

export const LoadingAnimation: React.FC<AnimationProps> = ({ width, height }) => {
  const uri = useStaticLottieUri(StaticImages.PaymentProcessingLoader);

  if (!uri) {
    return null;
  }

  return (
    <LottieView
      source={{ uri }}
      autoPlay
      loop
      style={
        isNative && {
          width,
          height,
          alignSelf: 'center',
        }
      }
      resizeMode="cover"
      enableMergePathsAndroidForKitKatAndAbove
    />
  );
};
